import React from "react";
import { Routes, Route } from "react-router-dom";
import DashboardLayout from "./Layout/DashboardLayout/DashboardLayout";
import DashboardPage from "./Pages/DashboardPage/DashboardPage";
import IndividualSearchPage from "./Pages/IndividualSearchPage/IndividualSearchPage";
import RecordsHandlingPage from "./Pages/RecordsHandlingPage/RecordsHandlingPage";

export default function AHPRAValidationToolRoutes() {
  return (
    <Routes>
      <Route path="/dashboard" element={<DashboardLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="individual-search" element={<IndividualSearchPage />} />
        <Route path="record-handling" element={<RecordsHandlingPage />} />
      </Route>
    </Routes>
  );
}
